/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

if (window.pandectesBannerSettings) {
  window.pandectesBannerSettings.widget = window.pandectesBannerSettings.widget || {};
  window.pandectesBannerSettings.widget.customTrigger = true;
}

// Basic async-friendly debounce helper so repeated triggers can still be awaited.
const debounce = (fn, delay = 250) => {
  let timer;
  let lastArgs;
  let lastContext;
  let pendingPromise = null;
  let resolvePromise;
  let rejectPromise;

  return function debounced(...args) {
    lastArgs = args;
    lastContext = this;

    if (timer) {
      clearTimeout(timer);
    }

    if (!pendingPromise) {
      pendingPromise = new Promise((resolve, reject) => {
        resolvePromise = resolve;
        rejectPromise = reject;
      });
    }

    timer = setTimeout(async () => {
      timer = null;
      const resolve = resolvePromise;
      const reject = rejectPromise;

      pendingPromise = null;
      resolvePromise = null;
      rejectPromise = null;

      try {
        const result = await fn.apply(lastContext, lastArgs);
        resolve(result);
      } catch (error) {
        reject(error);
      }
    }, delay);

    return pendingPromise;
  };
};

document.addEventListener('DOMContentLoaded', function(){
  const readMoreButtons = document.querySelectorAll(".readmore__expand-button");

  readMoreButtons.forEach(button => {
    button.addEventListener("click", function(){
      const readMoreContainer = button.closest(".readmore-container");

      readMoreContainer.classList.toggle("expanded");
    });
  });
});


var HeaderSearch = class extends CustomHTMLElement {
  connectedCallback() {
    this.inputElement = this.querySelector('[name="q"]');
    this.globalInputElement = document.querySelector('#globalHeaderSearchInput');
    this.globalCloseButton = document.querySelector('#globalHeaderSearchClose');
    this.closeButton = this.querySelector(".header__search-bar__reset")
    this.drawerContentElement = this.querySelector(".drawer__content");
    this.drawerFooterElement = this.querySelector(".drawer__footer");
    this.loadingStateElement = this.querySelector(".predictive-search__loading-state");
    this.resultsElement = this.querySelector(".predictive-search__results");
    this.defaultResults = this.querySelector(".predictive-search__results-default");
    this.searchOverlay = document.querySelector("#search__overlay");

    this.delegate.on("input", '[name="q"]', this._debounce(this._onSearch.bind(this), 200));
    this.delegate.on("click", '[name="q"]', this._openSearch.bind(this));
    this.delegate.on("click", '[data-action="reset-search"]', this._startNewSearch.bind(this));
    this.delegate.on("click", '[data-action="close-search"]', this._closeSearch.bind(this));
    this.searchOverlay.addEventListener("click", this._closeSearch.bind(this));
    this.globalInputElement.addEventListener("click", this._openSearch.bind(this));
    this.globalInputElement.addEventListener("input", this._debounce(this._onSearch.bind(this), 200));
    this.globalCloseButton.addEventListener("click", this._closeSearch.bind(this));
  }
  async _onSearch(event) {
    const target = event.target;

    if (this.abortController) {
      this.abortController.abort();
    }
    this.inputElement.value = target.value;

    this.drawerContentElement.classList.remove("drawer__content--center");
    this.drawerFooterElement.hidden = true;
    if (target.value === "") {
      this.loadingStateElement.hidden = true;
      this.resultsElement.hidden = true;
      this.defaultResults.hidden = false;
    } else {
      this.drawerContentElement.classList.add("drawer__content--center");
      this.loadingStateElement.hidden = false;
      this.resultsElement.hidden = true;
      this.defaultResults.hidden = true;
      let searchResults = {};
      try {
        this.abortController = new AbortController();
        if (this._supportPredictiveApi()) {
          searchResults = await this._doPredictiveSearch(target.value);
        } else {
          searchResults = await this._doLiquidSearch(target.value);
        }
      } catch (e) {
        if (e.name === "AbortError") {
          return;
        }
      }
      this.loadingStateElement.hidden = true;
      this.resultsElement.hidden = false;
      if (searchResults.hasResults) {
        this.drawerFooterElement.hidden = false;
        this.drawerContentElement.classList.remove("drawer__content--center");
      }
      this.resultsElement.innerHTML = searchResults.html;
    }
  }
  async _doPredictiveSearch(term) {
    const response = await fetch(`${window.themeVariables.routes.predictiveSearchUrl}?q=${encodeURIComponent(term)}&resources[limit]=10&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor&section_id=predictive-search`, {
      signal: this.abortController.signal
    });
    const div = document.createElement("div");
    div.innerHTML = await response.text();
    return { hasResults: div.querySelector(".predictive-search__results-categories") !== null, html: div.firstElementChild.innerHTML };
  }
  /* Some languages do not support predictive search API so we fallback to the Liquid search */
  async _doLiquidSearch(term) {
    const response = await fetch(`${window.themeVariables.routes.searchUrl}?q=${encodeURIComponent(term)}&resources[limit]=50&section_id=predictive-search-compatibility`, {
      signal: this.abortController.signal
    });
    const div = document.createElement("div");
    div.innerHTML = await response.text();
    return { hasResults: div.querySelector(".predictive-search__results-categories") !== null, html: div.firstElementChild.innerHTML };
  }
  _startNewSearch(focus = true) {
    this.activeSearchInput.value = "";
    if (focus) {
      this.activeSearchInput.focus();
    }

    const event = new Event("input", {
      bubbles: true,
      cancelable: true
    });
    this.activeSearchInput.dispatchEvent(event);
  }
  _openSearch() {
    this.open = true;

    this.closeButton.classList.remove("hidden");
    this.globalCloseButton.classList.remove("hidden");
  }
  _closeSearch() {
    this.open = false;

    this.inputElement.value = "";
    this.globalInputElement.value = "";
    this.closeButton.classList.add("hidden");
    this.globalCloseButton.classList.add("hidden");

    this._startNewSearch(false);
  }
  _supportPredictiveApi() {
    const shopifyFeatureRequests = JSON.parse(document.getElementById("shopify-features").innerHTML);
    return shopifyFeatureRequests["predictiveSearch"];
  }
  get activeSearchInput() {
    if (this.inputElement.offsetParent) {
      return this.inputElement;
    }

    return this.globalInputElement;
  }
  get open() {
    return this.hasAttribute("open");
  }
  set open(value) {
    document.documentElement.classList.toggle("lock-all", value);

    if (value) {
      this.setAttribute("open", "");
      this.searchOverlay.setAttribute("open", "");
    } else {
      this.removeAttribute("open");
      this.searchOverlay.removeAttribute("open");
    }
  }
  /**
   * Simple function that allows to debounce
   */
  _debounce(fn, delay3) {
    let timer = null;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(this, args);
      }, delay3);
    };
  }
};
window.customElements.define("header-search", HeaderSearch);

var KlaviyoTeaser = class extends CustomHTMLElement {
  connectedCallback() {
    this.closeButton = this.querySelector('.klaviyo-form-teaser__close');
    this.content = this.querySelector('.klaviyo-form-teaser__content');

    this.closeButton.addEventListener('click', this._close.bind(this));
    this.content.addEventListener("click", this._openForm.bind(this));
    this.klaviyoFormId = this.getAttribute('data-klaviyo-form-id');
  }

  _openForm(e) {
    e.preventDefault();

    if (!this.klaviyoFormId) {
      console.error("Klaviyo form ID is missing");
    }

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', this.klaviyoFormId]);

    this._close(e);
  }

  _close(e) {
    e.preventDefault();

    this.style.display = 'none';
  }
};
window.customElements.define("klaviyo-teaser", KlaviyoTeaser);

var ProductAddOnList = class extends CustomHTMLElement {
  connectedCallback() {
    if (this.dataset.cdlAccessoriesInitialized === 'true') {
      return;
    }

    const toggle = this.querySelector('[data-cdl-accessories-toggle]');
    const extras = this.querySelector('[data-cdl-accessories-extras]');
    if (!toggle || !extras) {
      return;
    }

    this.toggle = toggle;
    this.extras = extras;
    this.collapsedLabel = this.toggle.getAttribute('data-collapsed-label') || 'Show more';
    this.expandedLabel = this.toggle.getAttribute('data-expanded-label') || 'Show less';

    this.dataset.cdlAccessoriesInitialized = 'true';
    this._syncToggle();

    this.toggle.addEventListener('click', this._toggleExpanded.bind(this));
  }

  _syncToggle() {
    const isExpanded = this.extras.classList.contains('is-expanded');
    this.toggle.textContent = isExpanded ? this.expandedLabel : this.collapsedLabel;
    this.toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
  }

  _toggleExpanded() {
    this.extras.classList.toggle('is-expanded');
    this._syncToggle();
  }
};
window.customElements.define("cdl-product-addon-list", ProductAddOnList);


var ProductAddOn = class extends CustomHTMLElement {
  connectedCallback() {
    this.toggleButton = this.querySelector('.cdl-product-accessories__accessory__action');
    this.quantityInput = this.querySelector('.quantity-selector__input');

    this.toggleButton.addEventListener('click', this._addAddonToCart.bind(this));
    this.quantityInput.addEventListener('change', this._quantityChange.bind(this));
    this.addEventListener('click', this._toggleAddOn.bind(this));

    this.isActive = false;
    this.variantId = this.getAttribute('data-variant-id');
    this.productId = this.getAttribute('data-product-id');
    this.productTitle = this.getAttribute('data-product-title');
    this.parentProductId = this.getAttribute('data-parent-product-id');
    this.parentPoductTitle = this.getAttribute('data-parent-product-title');
    this.initialCartQuantity = this.getAttribute('data-initial-cart-quantity');
    this.currentCartQuantity = this.initialCartQuantity;
    this._debouncedUpdateCartQuantity = debounce(this._updateCartQuantity.bind(this), 250);

    if (this.initialCartQuantity > 0) {
      this._setIsActive(true);
    }
  }

  _toggleAddOn(e) {
    e.preventDefault();
    e.stopPropagation();

    if (!this.isActive) {
      this._addAddonToCart(e);
    }
  }

  async _addAddonToCart(e) {
    e.preventDefault();
    e.stopPropagation();

    const newStatus = !this.isActive;
    this._setCurrentCartQuantity(1);
    this._setIsActive(newStatus);

    try {
      await this._addToCart(1);
    } catch (e) {
      console.log("Failed to add addon to cart:", e);

      this._setCurrentCartQuantity(0);
      this._setIsActive(!newStatus);
    } finally {
      this._refreshCart();
    }
  }

  async _quantityChange(e) {
    const newCartQuantity = Number(e.target.value);

    await this._debouncedUpdateCartQuantity(newCartQuantity);
    this._refreshCart();

    this._setCurrentCartQuantity(newCartQuantity);

    if (newCartQuantity === 0) {
       this._setIsActive(false);
    }
  }

  async _addToCart(quantity) {
    const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
      body: JSON.stringify({
        items: [
          {
            id: this.variantId,
            quantity: quantity,
            properties: {
              _addonForProduct: this.parentPoductTitle,
              _addonForProductId: this.parentProductId
            }
          }
        ]
      }),
      method: "POST",
      headers: {
        "content-type": "application/json"
      }
    });

    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    return response;
  }

  async _updateCartQuantity(quantity) {
    const response = await fetch(`${window.themeVariables.routes.cartChangeUrl}.js`, {
      body: JSON.stringify({
        id: this.variantId,
        quantity: quantity,
      }),
      method: "POST",
      headers: {
        "content-type": "application/json"
      }
    });

    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    return response;
  }

  _refreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  }

  _setCurrentCartQuantity(quantity) {
    this.currentCartQuantity = quantity;
    this.quantityInput.value = quantity;
  }

  _setIsActive(status) {
    this.isActive = status;
    this.classList.toggle('is-active', status);
    this.toggleButton.classList.toggle('is-active', status);
    this.setAttribute('data-active', status);
  }
};
window.customElements.define("cdl-product-addon", ProductAddOn);

var CustomProductStickyForm = class extends ProductStickyForm {
  _setupVisibilityObservers() {
    const paymentContainerElement = document.getElementById("MainPaymentContainer").closest("form"), footerElement = document.querySelector(".shopify-section--footer"), stickyHeaderOffset = getStickyHeaderOffset();
    this._isFooterVisible = this._isPaymentContainerPassed = false;
    this.intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === footerElement) {
          this._isFooterVisible = entry.intersectionRatio > 0;
        }
        if (entry.target === paymentContainerElement) {
          const boundingRect = paymentContainerElement.getBoundingClientRect();
          this._isPaymentContainerPassed = entry.intersectionRatio === 0 && boundingRect.top + boundingRect.height <= stickyHeaderOffset;
        }
      });

      this.hidden = !this._isPaymentContainerPassed || this._isFooterVisible;
    });
    this.intersectionObserver.observe(paymentContainerElement);
    this.intersectionObserver.observe(footerElement);
  }
}
window.customElements.define("cdl-product-sticky-form", CustomProductStickyForm);

// Filter-pane GA4 tracking. Remove this block to disable the custom event.
document.addEventListener("openable-element:open", (event) => {
  if (event.target.id !== "facet-filters" || typeof window.gtag !== "function") {
    return;
  }

  window.gtag("event", "filter_pane_opened");
});

// Keep Focal's customer-facing cart badges from counting the managed B2B opening-fee line.
(() => {
  const visibleItemCount = (cart) => {
    if (Number.isFinite(cart.visible_item_count)) {
      return cart.visible_item_count;
    }

    return cart.items.reduce((count, item) => {
      const isOpeningFee = String(item.properties?._b2b_opening_fee) === "true";
      return count + (isOpeningFee ? 0 : item.quantity);
    }, 0);
  };

  const updateCartCounts = (event) => {
    const cart = event.detail?.cart;
    if (!Array.isArray(cart?.items)) {
      return;
    }

    const count = visibleItemCount(cart);
    document.querySelectorAll("cart-count").forEach((element) => {
      element.textContent = String(count);
    });
  };

  document.documentElement.addEventListener("cart:updated", updateCartCounts);
  document.documentElement.addEventListener("cart:refresh", updateCartCounts);
})();

// CDL popup: any link whose hash matches a popup's "Anchor link" setting opens that popup.
// Compare hashes so market-prefixed links (e.g. /en#guarantee-popup) still match.
document.addEventListener("click", (event) => {
  if (!(event.target instanceof Element)) {
    return;
  }

  const link = event.target.closest("a[href]");
  if (!link || !link.hash) {
    return;
  }

  const popup = Array.from(document.querySelectorAll("modal-content[data-cdl-anchor]")).find(
    (candidate) => new URL(candidate.getAttribute("data-cdl-anchor"), location.href).hash === link.hash
  );
  if (!popup) {
    return;
  }

  event.preventDefault();
  popup.open = true;
});
